import {forwardRef, InputHTMLAttributes} from 'react';
import {useFormControlContext} from '@/components/form/form-control/form-control';
import {useTextInputClassName} from '@/components/form/hooks/use-text-input-classname';

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  labelWithinInput?: string;
};

export default forwardRef<HTMLInputElement, InputProps>(function Input(
  {type = 'text', readOnly, labelWithinInput, ...props},
  ref,
) {
  const uuid = crypto.randomUUID();

  const {isDisabled} = useFormControlContext();

  const inputMergedClasses = useTextInputClassName({readOnly, isLabelWithingInput: !!labelWithinInput});

  return (
    <div className="flex w-full flex-col">
      <input
        autoComplete="off"
        data-1p-ignore
        disabled={isDisabled}
        readOnly={readOnly}
        type={type}
        ref={ref}
        className={inputMergedClasses}
        id={uuid}
        {...props}
      />

      {labelWithinInput && (
        <span className="pointer-events-none absolute inset-0 left-4 inline-flex items-center text-sm font-bold leading-none text-charcoal peer-hover:text-violet peer-focus:text-violet">
          {labelWithinInput}
        </span>
      )}
    </div>
  );
});
